export const frontmatter = {
    "draft": true,
    "title": "Ejemplos",
    "description": "Ejemplos de uso de la API de OnnIA.",
    "sidebar_label": "Ejemplos",
    "sidebar_group": "referencia",
    "sidebar_order": 4
}

export const toc = []